import React, { useState, useEffect } from 'react';
// styles
import useStyles from './styles';
import { useHistory ,useParams} from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Grid, Paper, Button } from '@material-ui/core';
// TabPanel, Accordion
import { TabPanel, ControlledAccordions } from '../';
import { validateForm,getBase64 } from '../../common/utils';
import { pathOr, clone } from 'ramda';
import { calculateTotal } from '../FormComponents/lineItem/calculate';
import { calculate_duration, add_custom_duration } from "../../common/duration_dependency";

const EditView = ({ id, data, module, onSubmit }) => {
	const { returnModule, returnRecord,recordName } = useParams();
	const {currentUserData} = useSelector((state) => state.config);
	const defaultReminderData = [{"idx":0,"id":"","popup":true,"email":true,"timer_popup":"1800","timer_email":"3600","del_invitees":[],"invitees":[{id:"",module_id:pathOr("",["data","id"],currentUserData),module:"Users","value":pathOr("",["data","attributes","name"],currentUserData),"name":pathOr("",["data","attributes","name"],currentUserData),"email":pathOr("",["data","attributes","email1"],currentUserData)}]}];
	let [initialValues, setInitialValues] = useState({});
	const [fields, setFields] = useState({});
	const [errors, setErrors] = useState({});
	let [lastCurrency, setLastCurrency] = useState([]);
	const { userPreference, config } = useSelector((state) => state.config);
	const configurator = pathOr([], ['hideShowConf', 'appConfigurator', module], config);
	const {disabledAlways,hiddenAlways,...rest}= configurator;
	// console.log("rest",rest)
	let [hiddenAll, setHiddenAll] = useState({hidden:hiddenAlways || [],disabled:disabledAlways || []});

	const CurrenciesRecords = pathOr([], ['attributes', 'CurrenciesRecords'], userPreference);
	// const calendar_dateformat = pathOr(config.default_date_format, ['attributes', 'global','calendar_dateformat'], userPreference);
	// const user_dateformat = pathOr(config.default_date_format, ['attributes', 'global','user_dateformat'], userPreference);
	// const time_format = pathOr(config.default_date_format, ['attributes', 'global','time_format'], userPreference);
	const calendar_format = pathOr(config.default_date_format, ['attributes', 'global', 'calendar_format'], userPreference);
	const date_reg_format = pathOr(config.default_date_format, ['attributes', 'global', 'date_reg_format'], userPreference);
	const time_reg_format = pathOr(config.default_date_format, ['attributes', 'global', 'time_reg_format'], userPreference);
	const date_reg_positions = pathOr(config.default_date_format, ['attributes', 'global', 'date_reg_positions'], userPreference);
	// const [Linedata,setLineData] = useState();
	const classes = useStyles();
	const history = useHistory();
	//const cchange = [];
	let [cchange, setCchange] = useState({});

	var isTab = false;
	useEffect(
		() => {
			// {
			let initialState = [];
			let fieldState = [];
			Object.keys(data).map((row) => {
				setValues(data[row].attributes, initialState, fieldState);
				data[row].panels &&
					data[row].panels.map((panelRow) => {
						setValues(panelRow.attributes, initialState, fieldState);
					});
			});
			initialValues = initialState;

			if (module === 'AOS_Quotes' || module === 'AOS_Invoices') {
				let calResult = calculateTotal(initialValues, CurrenciesRecords, fields, lastCurrency);
				setInitialValues({ ...initialValues, ...calResult });
			}
			else {
				setInitialValues({ ...initialValues, ...initialState });
			}
			if (typeof initialValues.primary_address_street === 'object' && initialValues.primary_address_street !== null && initialValues.primary_address_street) {
				setInitialValues({ ...initialValues, ...initialValues.primary_address_street });
			}
			if (typeof initialValues.alt_address_street === 'object' && initialValues.alt_address_street !== null && initialValues.alt_address_street) {
				setInitialValues({ ...initialValues, ...initialValues.alt_address_street });
			}
			if (typeof initialValues.billing_address_street === 'object' && initialValues.billing_address_street !== null && initialValues.billing_address_street) {
				setInitialValues({ ...initialValues, ...initialValues.billing_address_street });
			}
			if (typeof initialValues.shipping_address_street === 'object' && initialValues.shipping_address_street !== null && initialValues.shipping_address_street) {
				setInitialValues({ ...initialValues, ...initialValues.shipping_address_street });
			}
			if (module === 'Meetings') {
				let initialValuesData = clone(initialValues);
				//initialValuesData[field.name] =value;
				let date_start = initialValuesData.date_start || '';
				let date_end = initialValuesData.date_end || '';
				let duration = { duration: initialValuesData.duration || '', duration_hours: initialValuesData.duration_hours || '', duration_minutes: initialValuesData.duration_minutes || '' };
				if (!id) {
					duration.duration_hours = 0;
					duration.duration_minutes = 15;
					duration.duration = 900;
				}

				setInitialValues({ ...initialValuesData, ...duration });
			}
		},
		[data]
	);

	let count = 0;
	const setValues = (attributes, initialState, fieldState) => {
		attributes.map((rowField) => {
			rowField.map((field) => {
				setDependencyHidden(field,field.value);	
				if (field.type === 'line_item') {


					let linedata = pathOr('', ["linedata", "enable_group"], field) === 0 ? { 'ungrouped': pathOr([], ["linedata", "simple_data", "data"], field) } : { 'grouped': pathOr([], ["linedata", "groups_data", "data"], field) };
					return (
						field.name ? (initialState[field.name] = linedata ? linedata : '') : null,
						field.name ? (fields[field.name] = field) : null
					);
				} else if (field.type === 'parent') {
					return (
						field.name ? (initialState[field.name] = field.parent_name ? field.parent_name : { 'parent_name': '', 'parent_id': '', 'parent_type': '' }) : null,
						field.name ? (fields[field.name] = field) : null

					);
				} else if (field.type === 'file') {
					return (field.name ? (initialState[field.name] = field.value ? field.value : []) : null,
						field.name ? (fields[field.name] = field) : null
					)
				} else if (field.name === 'duration') {
					return (
						field.name ? (initialState[field.name] = field.value ? field.value : '0') : null,
						field.name ? (initialState['duration_hours'] = field.duration_hours || '0') : null,
						field.name ? (initialState['duration_minutes'] = field.duration_minutes || '0') : null,
						field.name ? (fields[field.name] = field) : null

					);
				} else if (field.type === 'decimal') {
					if (field.hasOwnProperty("decimalcurrency")) {
						(field.value === '') ? initialState[field.name] = 0.00 : initialState[field.name] = field.value;
						cchange[count] = field.name;
						setCchange(cchange);
						count++;
					}
				}  else if(field.module===returnModule && returnRecord  ){
                    return (
                        field.name ? (initialState[field.name] = returnRecord ? { 'id':returnRecord, 'value':recordName } : '') : null,

                        field.name ? (fields[field.name] = field) : null
                    );
                }else {
					return (
						field.name ? (initialState[field.name] = field.value ? field.value : '') : null,
						field.name ? (fields[field.name] = field) : null,
						field.name === 'currency_id' ? lastCurrency.push(field.value) : null
					);
				}
			
			});
		});

	};

	const setDependencyHidden = (field,value) =>{
		if(rest){
		const innerHiddenAlways = Object.values(rest).find(o =>o.fieldsSel[0] ===field.name);
		const newCaptureCond = pathOr([], ['condition'], innerHiddenAlways);

		const innCond = Object.values(newCaptureCond).find(o => o.field_value[0] === field.options ? field.options[value] : field.type==='bool'?value===0?'false':value?'true':'false':value);
		const hiddField = pathOr([], ['hiddenField'], innCond);
		if(field.type==='bool'){
		
			if (value==='0' || value===false) {
				let array3 = [...hiddenAll['hidden'], ...hiddField];
				array3 = array3.filter((item, index) => {
					return (array3.indexOf(item) == index)
				})
				setHiddenAll({ ...hiddenAll, 'hidden': array3 })
				
				// console.log("newValif22", array3, hiddenAll)
		
			} else  if(value!=='') {
				let array3 = [...hiddenAll['hidden'], ...hiddField];
				array3 = hiddenAll['hidden'].filter((item, index) => {
					return (hiddField.indexOf(item) !== index)
				})
				// console.log("newValelse22", array3)
				setHiddenAll({ ...hiddenAll, ['hidden']: array3 })

			}
		}else{
		if(innerHiddenAlways && value){
		
	
				const innerHiddenAlways2 = field.options?Object.values(newCaptureCond).find(o =>o.field_value[0] ===field.options[value])?Object.values(newCaptureCond).find(o =>o.field_value[0] ===field.options[value]):Object.values(newCaptureCond).find(o =>o.field_value[0] ===value):Object.values(newCaptureCond).find(o =>o.field_value[0] ===field.options[value]);
				// console.log("innerHiddenAlways2",innerHiddenAlways2,field,value,Object.values(innerHiddenAlways.condition))
				if(innerHiddenAlways2 && hiddField){
			
				let array3 = [...hiddenAlways, ...hiddField];
			
				 array3 = array3.filter((item,index)=>{
					return (array3.indexOf(item) == index)
				 })

				 setHiddenAll({...hiddenAll,['hidden']:array3})
				//  console.log("if",array3)
				}else{
					setHiddenAll({...hiddenAll,['hidden']:hiddenAlways})
					// setHiddenAll(hiddenAlways)
					// console.log("elssssse",hiddenAll)

				}
			}
		}
		}
	}
	
	const handleDateTimeChange = (date) => {
		let current_datetime = new Date(date);
		return current_datetime.getFullYear() + "-" + ("0" + (current_datetime.getMonth() + 1)).slice(-2) + "-" + ("0" + current_datetime.getDate()).slice(-2) + " " + ("0" + current_datetime.getHours()).slice(-2) + ":" + ("0" + current_datetime.getMinutes()).slice(-2) + ":" + ("0" + current_datetime.getSeconds()).slice(-2)
	};

	const getFormatedValue = () => {
		let init = clone(initialValues);
		for (let key in init) {
			if (typeof init[key] === "object" && (key !== 'line_items')) {
				if (key === 'parent_name') {
					init = { ...init, ...init[key] }
				}
			}
		}
		setInitialValues(init);

		for (let key in init) {
			// if (key.includes('date')) {
			// 	if(init[key])
			// 	{
			// 		let current_datetime = getDateObject(init[key]);
			// 		let formatedDate = current_datetime.getFullYear() + "-" + ("0" + (current_datetime.getMonth() + 1)).slice(-2) + "-" + ("0" + current_datetime.getDate()).slice(-2) + " " + ("0" + current_datetime.getHours()).slice(-2) + ":" + ("0" + current_datetime.getMinutes()).slice(-2) + ":" + ("0" + current_datetime.getSeconds()).slice(-2);
			// 		init = { ...init, [key]: formatedDate }
			// 	}
			// }
		}
		return init;
	}
	
	const onChange = (field, value) => {
		if(configurator && configurator.length){
		setDependencyHidden(field,value);
		}
		if (field.type === "relate") {
			// setInitialValues({ ...initialValues, [field.name]: value.value, [field.id_name]: value.id });
			setInitialValues({ ...initialValues, [field.name]: { 'value': value.value, 'id': value.id } });
			return;
		} else if (field.type === "parent") {
			setInitialValues({ ...initialValues, [field.name]: { ['parent_name']: value.parent_name, ['parent_id']: value.parent_id, ['parent_type']: value.parent_type } });
			return;
		}
		else if (field.type === "reminder_time") {
			// alert(field.name);
			setInitialValues({ ...initialValues, [field.name]: { ...value }.remindersData });
			return;
		}
		else if (field.type === 'file') {
			// let allFiles = [];

			// value !== '' && getBase64(value).then(
			// 	data => initialValues[field.name].push(data)
			// )

			if (module === 'Documents') {
				let current_datetime = new Date();
				let active_date = current_datetime.getFullYear() + "-" + ("0" + (current_datetime.getMonth() + 1)).slice(-2) + "-" + ("0" + current_datetime.getDate()).slice(-2);


				value ? getBase64(value).then(
					data => setInitialValues({ ...initialValues, [field.name]: [data], ['document_name']: value.name || '', ['revision']: '1', ['status_id']: 'Active' })
				) : setInitialValues({ ...initialValues, [field.name]: [{ name: null, file_content: '' }], ['document_name']: '' || '', ['revision']: '', ['status_id']: '' })
			} else {
				value ? getBase64(value).then(
					data => setInitialValues({ ...initialValues, [field.name]: [data] })

				) : setInitialValues({ ...initialValues, [field.name]: [{ name: null, file_content: '' }] })
			}
			return;
		} else if (field.type === 'image') {
			// let allFiles = [];
			value !== '' && getBase64(value).then(
				data => setInitialValues({ ...initialValues, [field.name]: [data] })
			)
			// initialValues[field.name] = allFiles[0];

			return;
		}
		if (field.type === 'line_item') {
			if (field.value === '') {
				initialValues[field.name] = value;
			}
		}
		if (field.name === 'currency_id') {
			lastCurrency.push(value)
			initialValues[field.name] = value;
		}

		if (module === 'AOS_Quotes' || module === 'AOS_Invoices') {
			initialValues[field.name] = value;
			let calResult = calculateTotal(initialValues, CurrenciesRecords, fields, lastCurrency, field.name);
			setInitialValues({ ...initialValues, ...calResult });
		} else {
			setInitialValues({ ...initialValues, [field.name]: value });

		}

		//if (module === 'Opportunities' && field.name === 'currency_id') {
		if (module !== 'AOS_Quotes' && field.name === 'currency_id') {
			initialValues[field.name] = value

			let id = initialValues.currency_id;
			if (id === -99.00 || id === -99 || id === "-99.00") {

			} else {

				let newRate = 1;
				let oldRate = 1;
				let getLastCurrency = lastCurrency[lastCurrency.length - 2];
				Object.values(CurrenciesRecords).map((getCurrency) => {
					if (getCurrency.id === id) {
						newRate = id === -99.00 || id === "-99.00" || id === "-99" ? 1 : getCurrency.conversion_rate;
					}
					if (getCurrency.id === getLastCurrency) {
						oldRate = getLastCurrency === -99.00 || getLastCurrency === "-99.00" || getLastCurrency === "-99" ? 1 : getCurrency.conversion_rate;
					}
				});
				let cchangeArray = [];
				Object.keys(cchange).map((field) => {
					//let convertVal = parseFloat(ConvertFromDollar(parseFloat(ConvertToDollar(parseFloat(unformat2Number(initialValues['amount'])), oldRate)), newRate));
					//setInitialValues({ ...initialValues, ['amount']: formatCurrency(convertVal) });

					let convertVal = parseFloat(ConvertFromDollar(parseFloat(ConvertToDollar(parseFloat(unformat2Number(initialValues[cchange[field]])), oldRate)), newRate));
					cchangeArray[cchange[field]] = formatCurrency(convertVal);
					//setInitialValues({ ...initialValues, [cchange[field]]: formatCurrency(convertVal) });
				});
				setInitialValues({ ...initialValues, ...cchangeArray });
			}

		}

		if (field.type === 'address' || field.name === 'alt_address_street' || field.name === 'primary_address_street') {
			setInitialValues({ ...initialValues, ...value });
		}
		if (module === 'Meetings' && (field.name === 'date_start' || field.name === 'date_end')) {
			let initialValuesData = clone(initialValues);
			initialValuesData[field.name] = value;
			let date_start = initialValuesData.date_start || '';
			let date_end = initialValuesData.date_end || '';
			let duration = { duration: initialValuesData.duration || '', duration_hours: initialValuesData.duration_hours || '', duration_minutes: initialValuesData.duration_minutes || '' };
			if (date_start && date_end) {
				duration = calculate_duration(date_start, date_end, calendar_format, date_reg_format, date_reg_positions, time_reg_format);
				handleMeetingDuration(data, duration.duration);
			}
			setInitialValues({ ...initialValuesData, ...duration });
		}

	};

	const handleMeetingDuration = (data, duration) => {
		let cstm = add_custom_duration(duration);
		data[0]['attributes'][3][0].options[cstm.value] = cstm.label;
		data[0]['attributes'][3][0].value = cstm.value;
	}
	const ConvertToDollar = (amount, rate) => {
		return amount / rate;
	}
	const ConvertFromDollar = (amount, rate) => {
		return amount * rate;
	}
	const unformat2Number = (num) => {

		// return unformatNumber(num, ',', ',');
		return num.toString().replace(/\$|\,/g, '');
	}
	const formatCurrency = (strValue) => {

		strValue = strValue.toString().replace(/\$|\,/g, '');
		let dblValue = parseFloat(strValue);

		let blnSign = (dblValue == (dblValue = Math.abs(dblValue)));
		dblValue = Math.floor(dblValue * 100 + 0.50000000001);
		let intCents = dblValue % 100;
		let strCents = intCents.toString();
		dblValue = Math.floor(dblValue / 100).toString();
		if (intCents < 10)
			strCents = "0" + strCents;
		for (var i = 0; i < Math.floor((dblValue.length - (1 + i)) / 3); i++)
			dblValue = dblValue.substring(0, dblValue.length - (4 * i + 3)) + ',' +
				dblValue.substring(dblValue.length - (4 * i + 3));

		return (((blnSign) ? '' : '-') + dblValue + '.' + strCents);
	}
	const isTime = (timeStr) => {
		var timeRegex = time_reg_format;
		timeRegex = timeRegex.replace(/[ ]*\([^)]*m\)/i, '');
		if (timeStr.length == 0) {
			return true;
		}
		let myregexp = new RegExp(timeRegex);
		if (!myregexp.test(timeStr)) {
			return false;
		}
		return true;
	}

	const getDateObject = (dtStr) => {
		if (dtStr.length === 0) {
			return true;
		}
		let myregexp = new RegExp(date_reg_format);
		if (myregexp.exec(dtStr)) {
			var dt = myregexp.exec(dtStr);
		}
		else {
			return false;
		}
		var yr = dt[date_reg_positions['Y']];
		var mh = dt[date_reg_positions['m']];
		var dy = dt[date_reg_positions['d']];
		var dtar = dtStr.split(' ');
		var date1 = '';
		if (typeof (dtar[1]) != 'undefined' && isTime(dtar[1], time_reg_format)) {
			var t1 = dtar[1].replace(/am/i, ' AM');
			t1 = t1.replace(/pm/i, ' PM');
			t1 = t1.replace(/\./, ':');
			date1 = new Date(mh + '/' + dy + '/' + yr + ' ' + t1);
		} else {
			date1 = new Date(mh + '/' + dy + '/' + yr);
		}
		if (isNaN(date1.valueOf())) {
			return null;
		}
		return date1;
	}
	const handleSubmit = (event) => {
		event.preventDefault();
		// alert("SUBMIT REQUEST")
		// return;
		// alert(initialValues.filename[0].name)
		let validate = validateForm(fields, initialValues, { calendar_format, date_reg_format, time_reg_format, date_reg_positions, view: id ? 'editview' : 'createview' });
		// return;
		setErrors(validate.errors);
		// return;
		if (validate.formIsValid) {
			var submitData = {
				data: {
					type: module,
					id: id,
					attributes: getFormatedValue(),
					// line_attributes:initialValues.line_items?initialValues.line_items:[],
				}
			};
			
			
		
		
			onSubmit(submitData);
		
		}
	};

	return (
		console.log("hiddenAll before",hiddenAll),
		<div className={classes.root}>
			<form onSubmit={handleSubmit} className={classes.root} noValidate autoComplete="off">
				<Paper key="editHeader" className={classes.paper}>
					{/* <Typography gutterBottom variant="subtitle1">
										{id ? 'Edit ' : 'Create '}
										{module}
									</Typography> */}
					<Grid container
						direction="row"
						justify="space-between"
						alignItems="center"
						spacing={2} style={{ margin: "-2px" }}>
						<Grid item>
							<Button type="submit" variant="contained" size="small" color="primary">
								Save
							</Button>
							<Button
								variant="contained"
								size="small"
								color="primary"
								onClick={history.goBack}
								className={classes.margin}
							>
								Cancel
							</Button>
						</Grid>
						<Grid item style={{ marginTop: '-9px' }}>

						</Grid>
					</Grid>
				</Paper>

				<Paper key="editBody" className={classes.paperEdit}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm container>
						
							{isTab ? (
								initialValues ? 	<TabPanel
									data={data}
									errors={errors}
									initialValues={initialValues}
									module={module}
									onChange={onChange}
									hiddenAll={hiddenAll}
								/> : null
							) : (
								initialValues ? <>{console.log("hiddenAll after",hiddenAll)}<ControlledAccordions
									data={data}
									errors={errors}
									initialValues={initialValues}
									module={module}
									headerBackground="true"
									onChange={onChange}
									hiddenAll={hiddenAll}

								// getDataLine={getDataLine}
								/> </>: null
							)}
						</Grid>
					</Grid>
				</Paper>
				<Paper key="editFooter" className={classes.paper}>
					<Grid container
						direction="row"
						justify="space-between"
						alignItems="center"
						spacing={2} style={{ margin: "-2px" }}>
						<Grid item>
							<Button type="submit" variant="contained" size="small" color="primary">
								Save
							</Button>
							<Button
								variant="contained"
								size="small"
								color="primary"
								onClick={history.goBack}
								className={classes.margin}
							>
								Cancel
							</Button>
						</Grid>

					</Grid>
				</Paper>
			</form>
		</div>
	);
};

export default EditView;
